import React from 'react';

import { connect } from 'react-redux';

import { Text, Stack } from '@nerdwallet/currency';
import { Num as num } from '@nerdwallet/nw-client-lib';

import { Outputs } from '../types';

export type PanelHeaderProps = {
  outputs: Outputs;
  monthlyDiff: number;
  benefitNPV: number;
  plannedStay: number;
};

const getPanelHeader = (plannedStay: number, outputs: Outputs) => {
  const rentingMonthlyCostNPV =
    outputs?.rentingSchedule[plannedStay - 1]?.monthlyCostNPV;

  const buyingMonthlyCostNPV =
    outputs?.buyingSchedule[plannedStay - 1]?.monthlyCostNPV;

  if (outputs.breakevenYear === null) {
    if (rentingMonthlyCostNPV < buyingMonthlyCostNPV) {
      return 'Buying will never be cheaper than renting';
    }

    return 'Renting will never be cheaper than buying';
  }

  if (rentingMonthlyCostNPV < buyingMonthlyCostNPV) {
    return `If you stay in your home for ${plannedStay} ${
      plannedStay < 2 ? 'year' : 'years'
    }, renting is cheaper than buying`;
  }
  if (rentingMonthlyCostNPV > buyingMonthlyCostNPV) {
    return `If you stay in your home for ${plannedStay} ${
      plannedStay < 2 ? 'year' : 'years'
    }, buying is cheaper than renting`;
  }

  return 'Buying and renting are about the same';
};

const getSavingText = (monthlyDiff: number, benefitNPV: number) => {
  return `You’ll save ${num.formatCurrency(
    Math.abs(monthlyDiff)
  )} per month and ${num.formatCurrency(Math.abs(benefitNPV), false)} in total`;
};

const PanelHeader = ({
  outputs,
  monthlyDiff,
  benefitNPV,
  plannedStay,
}: PanelHeaderProps): JSX.Element => {
  const { breakevenYear } = outputs;
  return (
    <Stack spacing="1">
      <Text bold>{getPanelHeader(plannedStay, outputs)}</Text>
      {breakevenYear && (
        <Text size="small">{getSavingText(monthlyDiff, benefitNPV)}</Text>
      )}
    </Stack>
  );
};

const mapStateToProps = (state) => ({
  outputs: state?.rentvsbuyCalculator?.outputs,
  plannedStay: state?.rentvsbuyCalculator?.plannedStay,
});

export default connect(mapStateToProps)(PanelHeader);
